import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import styles from './SbSharedRelatedItems.scss';
import { createFragmentContainer, graphql } from 'react-relay';
import { SbSharedItemTile } from '../SbSharedItemTile/SbSharedItemTile';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

const SbSharedRelatedItemsComponent = ({ searchBrowse, user, currency }) => {
    const relatedItems = get(searchBrowse, 'relatedItems.edges') || [];
    const isVerifiedTrade = get(user, 'isVerifiedTrade');
    const title = (
        <FormattedMessage id="sb.SbSharedRelatedItems.title" defaultMessage="Related Items" />
    );

    const relatedItemTiles = relatedItems.map(({ node }, index) => {
        return (
            <SbSharedItemTile
                user={user}
                key={node.serviceId}
                index={index}
                item={node}
                currency={currency}
                isVerifiedTrade={isVerifiedTrade}
                showSellerName={false}
                searchBrowse={searchBrowse}
            />
        );
    });
    if (relatedItems.length > 0) {
        return (
            <div>
                <BarHeader title={title} />
                <div className={styles.container}>{relatedItemTiles}</div>
            </div>
        );
    }
    return null;
};

SbSharedRelatedItemsComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
};

export const SbSharedRelatedItems = createFragmentContainer(SbSharedRelatedItemsComponent, {
    searchBrowse: graphql`
        fragment SbSharedRelatedItems_searchBrowse on SearchBrowseQueryConnection {
            ...SbSharedItemTile_searchBrowse
            relatedItems: thinBrowseRelatedItems(first: 12, seller: INCLUDE) {
                edges {
                    node {
                        ...SbSharedItemTile_item
                        serviceId
                    }
                }
            }
        }
    `,
    user: graphql`
        fragment SbSharedRelatedItems_user on User {
            isVerifiedTrade
            ...SbSharedItemTile_user
        }
    `,
});
